module.exports = __webpack_public_path__ + "static/media/CC-newpromo.64124912.png";